import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { ROUTES } from '../../utils';

function SuperAdminRoute({ children }) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (user?.role !== 'superadmin') {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return children;
}

export default SuperAdminRoute;
